import React, { Component } from 'react'
import './password-policy.css'
import { TickIcon } from '@myxplor/icons'
import DashIcon from './dash-icon.jsx'

class PasswordPolicyView extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    const {
      passwordState,
      errors
    } = this.props

    const lowercaseClass = passwordState.hasLowercase ? 'satisfied' : !errors ? 'unsatisfied' : 'error'
    const uppercaseClass = passwordState.hasUppercase ? 'satisfied' : !errors ? 'unsatisfied' : 'error'
    const numberClass = passwordState.hasNumber ? 'satisfied' : !errors ? 'unsatisfied' : 'error'
    const specialClass = passwordState.hasSpecial ? 'satisfied' : !errors ? 'unsatisfied' : 'error'
    const minLength = passwordState.hasMinLength ? 'satisfied' : !errors ? 'unsatisfied' : 'error'

    const Icon = <span><span className="tick"><TickIcon /></span><span className="dash"><DashIcon /></span></span>

    return (
      <div className="passwordPolicy">
        <ul>        
          <li className={lowercaseClass}>{Icon}1 lowercase character</li>
          <li className={uppercaseClass}>{Icon}1 uppercase character</li>
          <li className={numberClass}>{Icon}1 number</li>
          <li className={specialClass}>{Icon}1 special character</li>
          <li className={minLength}>{Icon}8 characters minimum</li>
        </ul>
      </div>
    )
  }
}

export default PasswordPolicyView



// WEBPACK FOOTER //
// ./src/password-policy/view.jsx